import React from 'react';

import { useAutomaticQuestions } from '../../../../../queries/v1/interview_intelligence/useAutomaticQuestions';
import { LoadingSpinner } from '../../../../../components/LoadingSpinner';
import { Interview } from '../../../../../entities/Interview';
import classNames from 'classnames';
import { InterviewMarkerList } from '../../../../../components/Interview/InterviewMarkerList';
import styles from './styles.module.scss';
import {
  AutomaticQuestion,
  AutomaticQuestionList,
} from '../../../../../entities/v1/interview_intelligence/AutomaticQuestion';
import { QueryObserverResult } from 'react-query';
import { EmptyTab } from '../../../../../components/EmptyTab';

interface PropTypes {
  interview: Interview;
  playTimestamp: number;
  onSelectTimestamp?: (timestamp: number) => void;
}

function QuestionsEmptyState() {
  return (
    <EmptyTab
      title='No Questions available yet'
      text='We are processing the interview questions. Please check back later.'
    />
  );
}

function QuestionBlock(props: {
  interview: Interview;
  playTimestamp: number;
  onSelectTimestamp?: (timestamp: number) => void;
  automaticQuestions: AutomaticQuestion[];
  refetch: (
    options?: unknown,
  ) => Promise<QueryObserverResult<AutomaticQuestionList, unknown>>;
}) {
  return (
    <InterviewMarkerList
      playTimestamp={props.playTimestamp}
      interview={props.interview}
      selectedHighlightType={'automatic_question'}
      automaticQuestions={props.automaticQuestions}
      refetchAutomaticQuestions={props.refetch}
      onSelectTimestamp={props.onSelectTimestamp}
      showResponses={true}
      showNameAndOffset={false}
      showContextQuestion={false}
    />
  );
}

export function Questions(props: PropTypes) {
  const {
    isLoading: isLoadingAutomaticQuestions,
    data: automaticQuestions,
    refetch,
  } = useAutomaticQuestions(props.interview.id, [
    'participant',
    'automatic_notes',
  ]);
  const interviewerAutomaticQuestions =
    automaticQuestions?.automaticQuestions.filter(
      (aq) => aq.automaticNotes.length > 0,
    ) || [];

  return (
    <div
      className={classNames(
        'mt-4',
        'w-100',
        'overflow-auto',
        'fs-5',
        styles['expandable-questions'],
      )}
      style={{ scrollBehavior: 'smooth' }}
    >
      {isLoadingAutomaticQuestions ? (
        <div style={{ minHeight: '250px' }}>
          <LoadingSpinner />
        </div>
      ) : interviewerAutomaticQuestions.length === 0 ? (
        <QuestionsEmptyState />
      ) : (
        <QuestionBlock
          {...props}
          automaticQuestions={interviewerAutomaticQuestions}
          refetch={refetch}
        />
      )}
    </div>
  );
}
